<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-07 13:19:44
 * @FilePath: \mrc-base-frontend\src\views\pushMessageTemplate\modules\addLang.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:16:13
-->
<template>
  <v-form ref="btnForm">
    <v-card class="dialog_card">
      <v-card-title class="card_title pa-2" :style="{ width: dialogWidth }">
        <div class="ml-3">{{ dialogTitle }}</div>
        <div class="close_dialog material-icons" @click="cancel">clear</div>
      </v-card-title>
      <v-card-text class="dialog_content">
        <v-row>
          <!-- title -->
          <v-col cols="12" sm="12" class="d-flex">
            <mrc_ess_multiText
              required
              style="width: 100%"
              :label="$t('label_The_title') + '*'"
              :readonly="onlyShow"
              :isNational="true"
              v-model="detailData.title"
              append-icon="mdi-longitude"
              :error-messages="$errors('detailData', 'title', requiredRule)"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="12" class="d-flex">
            <!-- 标题 -->
            <mrc_ess_multiTextarea
              required
              style="width: 100%"
              :label="$t('label_Body') + '*'"
              :isNational="true"
              :readonly="onlyShow"
              v-model="detailData.body"
              :error-messages="$errors('detailData', 'body', requiredRule)"
            >
            </mrc_ess_multiTextarea>
          </v-col>
        </v-row>
      </v-card-text>

      <mrc_ess_submitBtn
        class="py-6"
        v-if="!onlyShow"
        @cancel="cancel"
        @success="success"
        :successText="$t('label_save')"
      ></mrc_ess_submitBtn>
    </v-card>
  </v-form>
</template>

<script>
import { required, between } from "vuelidate/lib/validators";
export default {
  components: {},

  props: {
    dialogTitle: {
      type: String,
    },
    dialogWidth: {
      type: String,
    },
    dialogDefaultData: {
      type: Object,
    },
    onlyShow: {
      type: Boolean,
    },
    update_add: {
      type: Boolean,
    },
  },

  data() {
    return {
      detailData: {
        title: "", // 按钮名称
        body: "", // 按钮标题
      },
      uuid: "",
    };
  },
  validations: {
    detailData: {
      title: {
        required,
      },
      body: {
        required,
      },
    },
  },
  created() {},
  async mounted() {
    //   不支持 bj
    // await this.national("mrbase_sys_message_push_template_language");
    this.$nextTick(() => {
      this.dataShow(this.dialogDefaultData);
    });
  },
  methods: {
    // 弹窗数据回显
    dataShow(obj) {
      // 往弹窗传值才做下面的操作
      if (!Object.keys(obj).length) {
        return;
      }
      const data = this.$clone(obj);
      this.detailData = data;
      this.$refs.btnForm.resetValidation();
    },
    // 关闭dialog 不做修改
    cancel() {
      this.reset();
      this.$emit("cancel");
    },
    reset() {
      this.detailData = {
        title: "", // 按钮名称
        body: "", // 按钮标题
      };
    },
    // 保存
    success() {
      this.$v.detailData.$touch();
      if (this.$v.detailData.$error) {
        return;
      }
      const obj = this.$clone(this.detailData);
      this.$emit("getDetail", obj);
      this.reset();
    },
  },
  computed: {},
  watch: {
    dialogDefaultData: {
      handler(val) {
        this.dataShow(val);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.dialog_card {
  overflow: hidden;
}
.card_title {
  display: flex;
  justify-content: space-between;
  font-size: 14px !important;
  color: #fff;
  background-color: #000000;
}
.close_dialog {
  width: 32px;
  text-align: center;
  cursor: pointer;
}
</style>
